import React, { Component } from "react";
import "./ForgetPassword.scss";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { forgetPassword } from "../../../actions/authAction";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { ReactComponent as EmailLink } from "../../../assets/svg/email-link.svg";

class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userEmail: "",
        };
    }

    componentDidUpdate() {
        document.title = "Radarr | Forget Password";
    }

    onSubmit = () => {
        const userEmail = this.state.userEmail;
        const emailPattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (userEmail === "") {
            toast.error("Please enter your company email.");
            return;
        } else if (!emailPattern.test(userEmail)) {
            toast.error("Please enter a valid company email.");
        } else {
            let param = {};
            param["username"] = userEmail;
            this.props.forgetPassword(param).then((res) => {
                this.setUserEmail("");
            });
        }
    };
    setUserEmail = (userEmail) => {
        this.setState({ userEmail });
    };
    render() {
        return (
            <div className="forgetPassword">
                <div className="reset__form">
                    <h2 className="header__text">Account Recovery</h2>
                    <div className="info__content">
                        <EmailLink className="email__icon" title="Email" />
                        <span>Please provide your email id</span>
                        <p className="email__text">A verification link will be sent to your email.</p>
                    </div>
                    <label className="form__label">Company Email*</label>
                    <input
                        placeholder="Enter Company Email"
                        value={this.state.userEmail}
                        onChange={(ev) => {
                            this.setUserEmail(ev.target.value);
                        }}></input>
                    <button
                        className="submit__btn"
                        onClick={() => {
                            this.onSubmit();
                        }}>
                        <span>{!this.props.forgetPasswordLoading ? "Send" : <Loader inverted active size="small" />}</span>
                    </button>
                </div>
                <div className="route__btn">
                    <span className="signup__text">
                        Back to
                        <Link to="/signin" className="signin__text">
                            {" "}
                            Sign In
                        </Link>
                    </span>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        forgetPasswordLoading: state.authReducer.forgetPasswordLoading,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        forgetPassword: (data) => dispatch(forgetPassword(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);
